"use client";
import { useRef } from "react";
import Icon from "../../common/components/Icon";

const sanitizeQuantity = (newQuantity: string | number) => {
  return Math.max(
    1,
    Math.min(
      99,
      typeof newQuantity === "number" ? newQuantity : parseInt(newQuantity, 10),
    ),
  );
};

const CartQuantityStepper = ({ quantity, onQuantityChanged, onRemove }) => {
  const inputElement = useRef(null);

  const onChange = (e) => {
    if (e.target.value) {
      onQuantityChanged(sanitizeQuantity(e.target.value));
    }
  };

  const onIncrease = (e) => {
    const newQuantity = sanitizeQuantity(quantity + 1);
    inputElement.current.value = newQuantity;
    onQuantityChanged(newQuantity);
  };

  const onDecrease = (e) => {
    const newQuantity = sanitizeQuantity(quantity - 1);
    inputElement.current.value = newQuantity;
    onQuantityChanged(newQuantity);
  };

  const onBlur = (e) => {
    inputElement.current.value = quantity;
  };

  const deleteOnClick = (e) => {
    onRemove();
  };

  return (
    <div className="d-flex justify-content-end align-items-center flex-wrap pe-md-2">
      <div className="add-to-cart-wrapper">
        {quantity === 1 ? (
          <button
            type="button"
            className="no-button border-left-radius border"
            aria-label="Delete cart item"
            onClick={deleteOnClick}
          >
            <Icon icon="delete" className="icon--mdl" />
          </button>
        ) : (
          <button
            type="button"
            className="no-button border-left-radius border"
            aria-label="Decrease cart item"
            onClick={onDecrease}
          >
            <Icon icon="minus" />
          </button>
        )}
        <input
          type="text"
          pattern="\d+"
          className="form-field border border-radius"
          defaultValue={quantity}
          max={99}
          ref={inputElement}
          onBlur={onBlur}
          onChange={onChange}
        />
        <button
          className="no-button border-right-radius border"
          aria-label="Increase cart item"
          type="button"
          onClick={onIncrease}
        >
          <Icon icon="plus" />
        </button>
      </div>
    </div>
  );
};

export default CartQuantityStepper;
